module.exports = __webpack_public_path__ + "media/images/flags/ma-7a872eed88f6c3ffda09d2002e45b02c.png";